import axios from "axios";
import flow from "lodash/fp/flow";
import filter from "lodash/fp/filter";
import get from "lodash/fp/get";
import map from "lodash/fp/map";
import replace from "lodash/fp/replace";

const getImageNames = flow(
  map((a) => {
    try {
      return new URL(a).pathname;
    } catch {
      return null;
    }
  }),
  filter(Boolean),
  map(replace(/^.*[\\/]/, "")),
  map(replace(/\..+$/, ""))
);

export default function createImage({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({ images = [] }) => {
    if (images.length < 2) {
      return Promise.resolve(images[0]);
    }
    return axios({
      url: process.env.REACT_APP_CREATE_IMAGE_URL,
      method: "POST",
      cancelToken: source.token,
      data: { images: getImageNames(images) },
    })
      .then(get(["data", "final_image"]))
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log("Request canceled", error.message);
        } else {
          throw error;
        }
      });
  };
}
